import { cn } from "@/lib/utils";

interface FastSkeletonProps {
  className?: string;
  lines?: number;
  variant?: 'text' | 'circular' | 'rectangular';
}

export function FastSkeleton({ 
  className, 
  lines = 1, 
  variant = 'rectangular' 
}: FastSkeletonProps) {
  const getBaseClasses = () => {
    switch (variant) {
      case 'circular':
        return 'rounded-full aspect-square';
      case 'text':
        return 'rounded h-4';
      default:
        return 'rounded-md';
    }
  };

  if (lines === 1) {
    return (
      <div 
        className={cn(
          "animate-pulse bg-muted",
          getBaseClasses(),
          className
        )}
      />
    );
  }

  return (
    <div className="space-y-2">
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className={cn(
            "animate-pulse bg-muted",
            getBaseClasses(),
            i === lines - 1 ? 'w-3/4' : 'w-full',
            className
          )}
        />
      ))}
    </div>
  );
}